// import Swiper core, modules, and css
// import Swiper from 'swiper';
// import { Pagination, Autoplay, Navigation } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/pagination';

import './index.scss'
import { SplitText } from "./../../js/SplitText";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class ProductHeader {
    constructor($el) {
        this.$el = $el
    }
    init() {
        const masterTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: '.acf-product-header__sticky',
                start: 'top+=30 top',
                end: '+=1500',
                scrub: true,
                id: 'master-timeline',
                // markers: true,
            }
        })
        
        
        /*masterTimeline.set('.acf-product-header__sticky', {
            '--image--scroll-power': 0,
            '--gradient--opacity': 1,
            '--backdrop--opacity': 0,
            '--keywords--opacity': -1,
        })*/
        
        
        
        
        const heroShrink = () => {
            const tl = gsap.timeline()
            /*
            WHY SHOULD I NEED TO DO ANY OF THESE? WHY IS IT NOT WORKING?
            
            1. maybe gsap doesn't handle well having multiple timelines (or there's smth i'm missing)
            2. maybe gsap doesn't handle well css variables (well... poop.)
            
            // Force setting variables
            tl.set('.acf-product-header__sticky', {
                '--image--scroll-power': 0,
                '--gradient--opacity': 1,
                '--backdrop--opacity': 0,
                '--keywords--opacity': -1,
            }, 0.001)
            
            tl.fromTo('.acf-product-header__sticky', {
                '--image--scroll-power': 0,
                '--gradient--opacity': 1,
                '--backdrop--opacity': 0,
                '--keywords--opacity': -1,
            }, {
                '--image--scroll-power': 0,
                '--gradient--opacity': 1,
                '--backdrop--opacity': 0,
                '--keywords--opacity': -1,
            })
            */
            
            // Hero shrink
            tl.to('.acf-product-header__overflow-container', {
                scale: '0.92',
                duration: 1,
                ease: 'none',
            })
            // Image scrolls up
            tl.to('.acf-product-header__sticky', {
                '--image--scroll-power': 1,
                duration: 1,
            }, '<')
            // Image compensate shrinking and scrolls up
            tl.to('.acf-product-header__img', {
                scale: 1.08,
                duration: 1,
                ease: 'none',
            }, '<')
            // Cta container fade-out upwards
            tl.to('.acf-product-header__title-container', {
                y: '-20lvh',
                opacity: 0,
                duration: 1,
                ease: 'none',
            }, '<')
            return tl
        }
        const keywordsAppear = () => {
            const tl = gsap.timeline()
            // cta-container backdrop gradient fade-out
            // backdrop fade-in
            // keywords fade-in
            const $keywords = document.querySelector('.acf-product-header__keywords')
            
            tl.to('.acf-product-header__sticky', {
                '--gradient--opacity': 0,
                '--backdrop--opacity': $keywords ? 1 : 0,
                '--keywords--opacity': 1,
                duration: 1,
                ease: 'none',
            })
            // keywords goes up
            if ($keywords) {
                tl.fromTo('.acf-product-header__keywords', {
                    y: '100%',
                }, {
                    y: '0%',
                    duration: 1,
                    ease: 'none',
                }, '<')
            }
            return tl
        }
        const keywordsLeave = () => {
            const tl = gsap.timeline()
            // keywords scrolls-out upwards
            tl.fromTo('.acf-product-header__keywords', {
                y: '0%',
            }, {
                y: '-100%',
                duration: 1,
                ease: 'none',
            })
            // keywords backdrop fade-out
            tl.to('.acf-product-header__sticky', {
                '--backdrop--opacity': 0,
                duration: 1,
                ease: 'none',
            }, '<')
            // image scrolls to middleY
            tl.to('.acf-product-header__sticky', {
                '--image--scroll-power': 0.5,
                duration: 1,
            }, '<')
            return tl
        }
        
        masterTimeline
            .add(heroShrink())
            .add(keywordsAppear())
            .add(keywordsLeave())
        
        
        const $text = this.$el.querySelector('.acf-product-header__karaoke')
        if (!$text) return
        const textWordsArr = new SplitText($text, { 
            splitChars: false, 
        })
        
        gsap.to(textWordsArr.words, {
            opacity: 1,
            stagger: 0.1,
            ease: 'steps(1)',
            scrollTrigger: {
                trigger: $text,
                start: 'top 80%',
                end: 'bottom 80%',
                id: 'hero-karaoke',
                scrub: true,
                // pin: true,
                // markers: true, // debug only
                once: true,
            }
        })
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    ;[ ...document.querySelectorAll('.acf-product-header') ].forEach($block => {
        $block.expandygg = new ProductHeader($block)
    })
}, {capture: false, passive: true, once: true} || false)
